import { countryName } from './countries';
import { Address } from '@/api/business-partner/business-partner.types.ts';

export function formatAddressNewLine(address: Partial<Address>) {
  return `${(address.addressName2 && `${address.addressName2}\n`) || ''}${
    (address.addressName3 && `${address.addressName3}\n`) || ''
  }${(address.street && `${address.street}\n`) || ''}${
    (address.zipCode && `${address.zipCode} `) || ''
  }${(address.city && `${address.city}\n`) || ''}${
    (address.country && `${countryName(address.country)}\n`) || ''
  }`;
}
